import React, { useState } from 'react';

import { FormInput } from '@/components/shared/Inputs';
import { Blurb } from '@/components/shared/Inputs/Blurb';
import { Label } from '@/components/shared/Inputs/Label';
import { SingleActionLayout } from '@/components/shared/SingleActionLayout/SingleActionLayout';
import { TeamSong } from '@/graphql';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { AddCustomSongDisplayProps } from '../AddCustomSong';
import styles from './Lyrics.module.scss';

type FormSchema = {
	lyrics?: string;
};

type Props = {
	teamSong: Partial<Pick<TeamSong, 'lyrics'>>;
	onSubmit: (values: { lyrics: TeamSong['lyrics'] }) => void;
};

const validationSchema: Yup.SchemaOf<FormSchema> = Yup.object().shape({
	lyrics: Yup.string()
		.optional()
		.max(5000, 'Can not be more than 5000 characters'),
	// spotifyId: Yup.string().required('Please enter a valid url'),
});

export const Lyrics: React.FC<Props> = ({ teamSong, onSubmit }) => {
	const { lyrics } = teamSong;
	const [touched, setTouched] = useState(false);
	const initialValues: FormSchema = {
		lyrics: lyrics || '',
	};
	return (
		<Formik
			key="asaphSignUn"
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={(values) => {
				onSubmit({
					lyrics: values.lyrics || null,
				});
			}}
		>
			{({ handleSubmit, handleChange, values, errors, isValid }) => (
				<SingleActionLayout
					actionLabel="Save"
					actionDisabled={!isValid || !touched}
					onActionClick={handleSubmit}
				>
					<form
						onSubmit={handleSubmit}
						id="asaphSignIn"
						className={styles['root']}
					>
						<Label>Song Lyrics</Label>
						<textarea
							placeholder="Add song lyrics"
							name="lyrics"
							id="lyrics"
							autoComplete="off"
							value={values.lyrics}
							onChange={(e) => {
								setTouched(true);
								handleChange(e);
							}}
						/>
						<Blurb>Separate verses by using new lines</Blurb>
						{errors.lyrics && (
							<Blurb isError>{errors.lyrics}</Blurb>
						)}
					</form>
				</SingleActionLayout>
			)}
		</Formik>
	);
};
